(function () {
  'use strict';

  var STORAGE_KEY = 'plp-packshot';

  // --- Storage helpers (safe against private-browsing restrictions) ---

  function getStoredState() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) === true;
    } catch (_) {
      return false;
    }
  }

  function setStoredState(value) {
    try {
      localStorage.setItem(STORAGE_KEY, String(value));
    } catch (_) {}
  }

  // --- DOM helpers ---

  function getCheckbox() {
    return document.getElementById('inverse-packshots');
  }

  function isPackshotActive() {
    var cb = getCheckbox();
    return cb ? cb.checked : getStoredState();
  }

  // --- Packshot state ---

  function applyPackshotState(active) {
    var loop = document.getElementById('CollectionLoop');
    if (!loop) return;

    loop.classList.toggle('inverse', active);

    // .loaded drives opacity on mobile (no-touch CSS covers desktop via .inverse)
    document.querySelectorAll('.product-item__bg__under').forEach(function (el) {
      if (el.children.length > 0) {
        el.classList.toggle('loaded', active);
      }
    });
  }

  function initToggle() {
    var checkbox = getCheckbox();
    if (!checkbox) return;

    var stored = getStoredState();
    checkbox.checked = stored;
    if (stored) applyPackshotState(true);

    // 'change' fires on click AND keyboard (space bar), unlike 'click'
    checkbox.addEventListener('change', function () {
      applyPackshotState(this.checked);
      setStoredState(this.checked);
    });
  }

  // --- MutationObserver: survive filter/sort DOM replacement ---
  //
  // Shopify filter/sort can replace #CollectionLoop entirely (not just update
  // its children). Watching the element itself leaves a stale observer on a
  // detached node. Instead we watch the nearest stable ancestor so we catch:
  //   1. #CollectionLoop being swapped out by a filter/sort AJAX render
  //   2. New product <li> items appended by infinite scroll
  //   3. Images lazy-loaded into existing product items
  //
  // Class changes (.inverse, .loaded) are attribute mutations — they do NOT
  // trigger a childList observer, so there is no risk of an infinite loop.

  var productsObserver = null;
  var applyTimer;

  function scheduleApply() {
    clearTimeout(applyTimer);
    applyTimer = setTimeout(function () {
      applyPackshotState(isPackshotActive());
    }, 60);
  }

  function observeProductsContainer() {
    if (productsObserver) {
      productsObserver.disconnect();
      productsObserver = null;
    }

    // .collection__products is the stable wrapper that survives filter updates
    var container = document.querySelector('.collection__products, .collection-products');
    if (!container) return;

    productsObserver = new MutationObserver(scheduleApply);
    productsObserver.observe(container, { childList: true, subtree: true });
  }

  // --- Mobile DOM rearrangement with restore on desktop resize ---

  var mobileMedia = window.matchMedia('(max-width: 768px)');
  var movedItems = [];
  var resizeTimer;

  function saveAndMove(el, target) {
    if (!el || !target || target.contains(el)) return;
    movedItems.push({ el: el, parent: el.parentNode, next: el.nextSibling });
    target.appendChild(el);
  }

  function restoreMovedItems() {
    // Reverse order preserves original DOM sequence
    movedItems.slice().reverse().forEach(function (item) {
      if (item.parent && !item.parent.contains(item.el)) {
        item.parent.insertBefore(item.el, item.next);
      }
    });
    movedItems = [];
  }

  function moveForMobile() {
    var navRight = document.querySelector('.collection_nav--right');
    if (!navRight) return;

    if (mobileMedia.matches) {
      navRight.style.display = 'none';

      var popoutGroup = document.querySelector('.popout--group');
      if (!popoutGroup) return;

      var showPackshot = document.querySelector('.show_packshot');
      var collectionSorting = document.querySelector('.popout--sort, [data-collection-sorting]');

      saveAndMove(showPackshot, popoutGroup);
      if (showPackshot) showPackshot.style.display = 'flex';
      saveAndMove(collectionSorting, popoutGroup);
    } else {
      restoreMovedItems();
      navRight.style.display = 'flex';
    }
  }

  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(moveForMobile, 150);
  }

  // --- Lifecycle ---

  var initialized = false;

  function teardown() {
    if (productsObserver) {
      productsObserver.disconnect();
      productsObserver = null;
    }
    window.removeEventListener('resize', onResize);
    clearTimeout(resizeTimer);
    clearTimeout(applyTimer);
    movedItems = [];
    initialized = false;
  }

  function init() {
    if (initialized) return;
    initialized = true;

    initToggle();
    moveForMobile();
    observeProductsContainer();
    window.addEventListener('resize', onResize);
  }

  // Shopify theme editor: section replaced when settings change
  document.addEventListener('shopify:section:unload', teardown);
  document.addEventListener('shopify:section:load', function () {
    teardown();
    init();
  });

  // Standard page load — defer ensures readyState is 'interactive' or 'complete'
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
